
// Modules
import * as THREE from "three"
import gsap from "gsap"

// HelpersThree
import Cylinder2 from '../Cylinder2'
import Cylinder2Old from '../Cylinder2Old'
import SceneWithRaycaster from "./SceneWithRaycaster"
import utils from "../../../utils/utils"

// Data

// Constants
const INFINITE_ROTATION_Y_SPEED =  .00075

const TILT_EASE = .05
const TILT_REDUCER_X = .4
const TILT_REDUCER_Y = .05


const CYLINDER_COLOR_SECONDARY = 0x999999
const CYLINDER_COLOR_PRIMARY = 0xffffff


const randomVideos = [
    "https://ubiquity.tv/backend/media/pages/slider/audrey-mascina-lancome-idole-l-intense/870123934-1600247520/slider_idole-l-intense.mp4",
    "https://ubiquity.tv/backend/media/pages/slider/repetto/3406780540-1599891895/1.-repetto-manifeste-audrey-mascina.mp4",
    "https://ubiquity.tv/backend/media/pages/slider/lancome/2702929876-1599891895/2.-lancome-idoles-audrey-mascina.mp4",
    "https://ubiquity.tv/backend/media/pages/slider/lancome-voices/1088241513-1599891895/3.-lancome-voices-chris-roman-_h.264.mp4",
]
export default class SceneDirectors extends SceneWithRaycaster{
    constructor(container, parameters, data = {}){
        super(container, {
            rendererAlpha: true,
            ...parameters
        }, data)

        // variables
        this._cameraTargetPosition = new THREE.Vector3()
        
        // data
        this._directors = data.directors
        this._updateRoute = data.updateRoute
    
        // binds
        this.onClickMesh = this.onClickMesh.bind(this)
        this.onMouseTilt = this.onMouseTilt.bind(this)

        // penchement
        this._targetMouse = new THREE.Vector2()
        this._currentMouse = new THREE.Vector2()
        this._canTilt = true

        window.SceneDirectors = this
    }

    /** Build */

    initScene(){
        super.initScene()

        // set camera
        this.camera.position.z = 10

        // tilting container
        this._tiltingContainer = new THREE.Group()
        this.scene.add(this._tiltingContainer)

        this._cylindersContainer = new THREE.Group()
        this._tiltingContainer.add(this._cylindersContainer)
        this._cylindersContainer.rotation.x = -Math.PI / 64
        this._cylindersContainer.rotation.z = -Math.PI / 16

        let offsetY = 0

        for(let i = 0; i < this._directors.length; i++){

            let name = this._directors[i].name.toUpperCase()

            let cylinder = new Cylinder2Old([
                {text: name, fontFamily: "GrtskMegaBold", fontWeight: 700, fontSize: 50},
                {text: name, fontFamily: "GrtskPetaBold", fontWeight: 700, fontSize: 35, letterSpacing: 6},
            ], {
                cylinderRadius: 5,
                repeat: 6,
                ratio: 100,
                side: THREE.FrontSide,
                radialSegments: 256,
                alphaTest: .3
            }).getMesh()

            // transform cylinder
            cylinder.position.y += offsetY
            cylinder.rotation.y = Math.random() * Math.PI * 2

            // user data
            let rotationSpeed = utils.randomInteger(600, 1000) * 1e-3

            cylinder.userData.rotationSpeed = rotationSpeed
            cylinder.userData.initialRotationSpeed = rotationSpeed
            cylinder.userData.directorId = this._directors[i].id
            cylinder.userData.slug = this._directors[i].slug
            
            // backgorund media
            let type = this._directors[i].backgroundVideo ? "video" : this._directors[i].backgroundImage ? "image" : null

            cylinder.userData.backgroundMedia = type ? {
                type: type,
                src: this._directors[i].backgroundVideo || this._directors[i].backgroundImage
            } : null
            
            // add to scene
            this._cylindersContainer.add(cylinder)
            
            // increment offset
            offsetY += -cylinder.geometry.parameters.height * 1.1

        }

        // center cylinders
        this._cylindersContainer.children.map(c => {
            c.position.y += (-offsetY * .5 + (offsetY / this._directors.length) * .5) * .85 // fix center-y decalage
        })

        this.intersectableObjects = this._cylindersContainer.children
    }

    /** Animate */

    _animateEntrance(){
        gsap.from(this.container, {
            duration: .6,
            opacity: 0
        })
    }

    _animateExit(onComplete){
        gsap.to(this.container, {
            duration: .6,
            onComplete: onComplete,
            opacity: 0
        })
    }

    onRender(){

        this.camera.lookAt(this._cameraTargetPosition)

        // infinite rotate
        for(let i = 0; i < this._cylindersContainer.children.length; i++){

            let child = this._cylindersContainer.children[i]
            let rotationSpeed = child.userData.rotationSpeed

            child.rotateY(INFINITE_ROTATION_Y_SPEED * rotationSpeed)
        }

        // tilting
        let tilting = utils.getRestrictedTiltingRotation(this._currentMouse, this._targetMouse, TILT_EASE)

        this._tiltingContainer.rotation.x = -tilting.tiltingX * TILT_REDUCER_Y
        this._tiltingContainer.rotation.z = -tilting.titlingZ * TILT_REDUCER_X

        this._currentMouse.set(tilting.nextX, tilting.nextY)
    }


    /** Events */

    onClickMesh(){


        let mesh = this.hoveredMesh

        if(mesh){
            this._updateRoute(mesh.userData.slug)
        }

    }

    onMouseEnterMesh(intersect){
        super.onMouseEnterMesh(intersect)

        let mesh = intersect.object

        // show media bg
        this.toggleMediaBg(true, mesh.userData.backgroundMedia.type, mesh.userData.backgroundMedia.src)
        
        // pointer clickable
        document.body.style.cursor = "pointer"

        // animate opacity
        mesh.material.transparent = true
        gsap.to(mesh.material, {

            duration: .5,

            opacity: .51

        })

        // reduce rotation speed
        gsap.to(mesh.userData, {
            duration: 1,

            rotationSpeed: .35
        })

    }

    toggleMediaBg(state, type, src){


        console.log("toggleMedia", {state, type, src})


        // enable
        if(state){

            let elementTarget = type === "image" ? this.data.mediaBgImage : this.data.mediaBgVideo
            let disabledTarget = type === "image" ? this.data.mediaBgVideo : this.data.mediaBgImage
            
    
            if(elementTarget){
                

                gsap.to(this.data.mediaBgImage.parentElement, {
                    duration: .5,
                    delay: .5,
                    onStart: () => {
                        elementTarget.src = src
                        elementTarget.classList.add("active")
                    },

                    opacity: 1,
                })
                
            }

        } 
        
        // disable
        else {

            gsap.to(this.data.mediaBgImage.parentElement, {
                duration: .5,
                onComplete: () => {
                    this.data.mediaBgVideo.src = null
                    this.data.mediaBgImage.src = null 
                    this.data.mediaBgVideo.classList.remove("active")
                    this.data.mediaBgImage.classList.remove("active") 
                },

                opacity: 0,
            })
        
        }


    }

    onMouseLeaveMesh(){

        let mesh = this.hoveredMesh

        // animate opacity
        gsap.to(mesh.material, {

            duration: .5,
            
            opacity: 1
        })

        // pointer clickable
        document.body.style.cursor = ""

        // restore rotation speed
        gsap.to(mesh.userData, {
            duration: 1,

            rotationSpeed: mesh.userData.initialRotationSpeed
        })

        // hide bg media
        this.toggleMediaBg(false)

        super.onMouseLeaveMesh()

    }

    onMouseTilt(event){

        let currentMouse = utils.getMousePosition(event)

        this._targetMouse.set(
            currentMouse[0],
            currentMouse[1]
        )
    }

    attachEvents(){
        super.attachEvents()
        this.container.addEventListener("click", this.onClickMesh)
        this.container.addEventListener("mousemove", this.onMouseTilt)
    }

    removeEvents(){
        super.removeEvents()
        this.container.removeEventListener("click", this.onClickMesh)
        this.container.removeEventListener("mousemove", this.onMouseTilt)
    }


    /** Core */

    start(){
        this._animateEntrance()
        super.start()
    }

    stop(){
        
        // restore pointer
        document.body.style.cursor = ""

        super.stop()
    }
}